/* unplugin-vue-components disabled */import { render } from "./UploadAndCropSingleImage.vue?vue&type=template&id=3e6949c9&scoped=true"
import script from "./UploadAndCropSingleImage.vue?vue&type=script&lang=js"
export * from "./UploadAndCropSingleImage.vue?vue&type=script&lang=js"

import "./UploadAndCropSingleImage.vue?vue&type=style&index=0&id=3e6949c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e6949c9"]])

export default __exports__